/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  createNativeWhatsappChannel(params) {
    return axios.post(
      `${this.url.replace(/inboxes$/, '')}callbacks/create_native_whatsapp_channel`,
      params
    );
  }

  getWhatsappGoQr(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_go_qr`);
  }

  getWhatsappGoStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_go_status`);
  }

  connectWhatsappGo(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_connect`);
  }

  pairWhatsappGo(inboxId, phone) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_pair`, { phone });
  }

  disconnectWhatsappGo(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_disconnect`);
  }

  // ─── WhatsApp Group Management ───

  getWhatsappGoGroups(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_go_groups`);
  }

  getWhatsappGoMyGroups(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_go_my_groups`);
  }

  getWhatsappGoGroupInfo(inboxId, groupJid) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_group_info`, {
      groupJid,
    });
  }

  createWhatsappGoGroup(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_go_group_create`,
      params
    );
  }

  updateWhatsappGoGroupParticipant(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_go_group_participant`,
      params
    );
  }

  updateWhatsappGoGroupName(inboxId, groupJid, name) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_group_name`, {
      groupJid,
      name,
    });
  }

  updateWhatsappGoGroupDescription(inboxId, groupJid, description) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_go_group_description`,
      { groupJid, description }
    );
  }

  updateWhatsappGoGroupPhoto(inboxId, groupJid, image) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_group_photo`, {
      groupJid,
      image,
    });
  }

  getWhatsappGoGroupInviteLink(inboxId, groupJid) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_go_group_invite_link`,
      { groupJid }
    );
  }

  joinWhatsappGoGroup(inboxId, inviteCode) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_group_join`, {
      inviteCode,
    });
  }

  leaveWhatsappGoGroup(inboxId, groupJid) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_group_leave`, {
      groupJid,
    });
  }

  updateWhatsappGoGroupSettings(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_go_group_settings`,
      params
    );
  }

  getWhatsappGoGroupRequests(inboxId, groupJid) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_go_group_requests`, {
      groupJid,
    });
  }

  updateWhatsappGoGroupRequests(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_go_group_requests_update`,
      params
    );
  }
}

export default new Inboxes();
